import moment from 'moment'

export const dateMask = (value: any) => {
  if (value) {
    // Remove todos os caracteres não numéricos
    value = value.replace(/\D/g, '')

    // Adiciona a barra (/) enquanto o usuário digita a data
    if (value.length > 2 && value.length <= 4) {
      value = value.replace(/^(\d{2})(\d{1,2})/, '$1/$2')
    } else if (value.length > 4) {
      value = value.replace(/^(\d{2})(\d{2})(\d{1,4})/, '$1/$2/$3')

      // Verifica se a data é válida
      const day = parseInt(value.substring(0, 2))
      const mounth = parseInt(value.substring(3, 5))
      const year = parseInt(value.substring(6, 10))

      // Limita a entrada de valuees inválidos durante a digitação
      if (isNaN(day) || day < 1 || day > 31) {
        // O dia não é válido
        return { success: false, value: value, message: 'Dia inválido' }
      } else if (isNaN(mounth) || mounth < 1 || mounth > 12) {
        // O mês não é válido
        return { success: false, value: value, message: 'Mês inválido' }
      } else if (isNaN(year) || year < 1970) {
        // O ano não é válido
        return { success: false, value: value, message: 'Ano inválido' }
      } else if (
        (mounth === 4 || mounth === 6 || mounth === 9 || mounth === 11) &&
        day > 30
      ) {
        // O dia não é válido para mes com 30 dias
        return {
          success: false,
          value: value,
          message: `O mês ${mounth} só tem 30 dias`,
        }
      } else if (mounth === 2) {
        // Verifica o dia para o mês de fevereiro
        const daysInFebruary =
          (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28
        if (day > daysInFebruary) {
          return {
            success: false,
            value: value,
            message: `O mês ${mounth} só tem ${daysInFebruary} dias`,
          }
        }
      }
      // A data é válida
      return { success: true, value: value }
    }

    return { success: true, value: value }
  }

  return { success: true, value: value }
}

export const formatDateToISOString = (data: string) => {
  const regexIsoString = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/ // expressão regular para verificar se a data está no formato ISOstring

  if (regexIsoString.test(data)) {
    // se a data já estiver no formato ISOstring, retorna a própria data
    return data
  } else {
    // se a data não estiver no formato ISOstring, converte para ISOstring
    const partesData = data.split('/')
    const dataIsoString = `${partesData[2]}-${partesData[1].padStart(
      2,
      '0',
    )}-${partesData[0].padStart(2, '0')}T00:00:00.000Z`

    return dataIsoString
  }
}

export const formatDateToDayMounthYear = (date: string) => {
  const momentDate = moment(date, 'YYYY-MM-DD')
  return momentDate.isValid() ? momentDate.format('DD/MM/YYYY') : date
}

export const formatDateToYYYYMMDD = (date: string) => {
  const momentDate = moment(date, 'DD/MM/YYYY')
  return momentDate.isValid() ? momentDate.format('YYYY-MM-DD') : date
}

export const isDateStringValid = (input: string) => {
  // Expressão regular para verificar se a string se parece com uma data
  const datePattern =
    /^([A-Za-z]{3}) ([A-Za-z]{3}) (\d{2}) (\d{4}) (\d{2}):(\d{2}):(\d{2}) (\w{3})(\d{4})$/
  return datePattern.test(input)
}

export const isDateISOString = (input: string) => {
  const isoRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.\d{3}Z$/
  return isoRegex.test(input)
}

export function convertToISOString(date: string) {
  if (typeof date !== 'string') {
    return ''
  }

  const minDate = new Date('1990-01-01')

  // Tenta converter a data diretamente
  const parsedDate = new Date(formatDateToYYYYMMDD(date))
  if (!isNaN(parsedDate.getTime())) {
    if (parsedDate < minDate) {
      return ''
    }

    // Tenta lidar com os formatos dd-mm-yyyy, dd/mm/yyyy, ddmmYYYY
    const match = date.match(/^(\d{2})[-/]?(\d{2})[-/]?(\d{4})$/)
    if (match) {
      const [, day, month, year] = match
      const formattedDate = new Date(`${year}-${month}-${day}`)
      if (formattedDate < minDate) {
        return ''
      }

      // Ajusta a data para o fuso horário UTC antes de retornar a representação ISO
      const adjustedFormattedDate = new Date(
        formattedDate.getTime() - formattedDate.getTimezoneOffset() * 60000,
      )
      return adjustedFormattedDate.toISOString()
    }
  }

  return ''
}

export function convertToDateISOString(date: string) {
  if (typeof date !== 'string') {
    return ''
  }

  const currentDate = new Date()
  const minDate = new Date('1990-01-01')

  // Tenta converter a data diretamente
  const parsedDate = new Date(date)
  if (!isNaN(parsedDate.getTime())) {
    if (parsedDate > currentDate || parsedDate < minDate) {
      return ''
    }
    return parsedDate.toISOString()
  }

  // Tenta lidar com os formatos dd-mm-yyyy, dd/mm/yyyy, ddmmYYYY
  const match = date.match(/^(\d{2})[-/]?(\d{2})[-/]?(\d{4})$/)
  if (match) {
    const [, day, month, year] = match
    const formattedDate = new Date(`${year}-${month}-${day}`)
    if (formattedDate > currentDate || formattedDate < minDate) {
      return ''
    }
    return formattedDate.toISOString()
  }
  return ''
}

export const completeDate = (val: any) => {
  if (isDateISOString(val)) {
    return true
  }
  if (val && val.length < 8) {
    return true
  }
  return false
}

export const timeStampToDate = (val: number) => {
  if (!val) return 'N/A'
  return moment.unix(val).format('DD/MM/YYYY')
}
